import { z } from 'zod/v3';

// ===== Training Quiz DTOs =====

export const TrainingQuizQuestionDTOSchema = z.object({
  question: z.string(),
  options: z.array(z.string()).length(4),
  correctIndex: z.number().int().min(0).max(3),
  explanation: z.string(),
});

export type TrainingQuizQuestionDTO = z.infer<typeof TrainingQuizQuestionDTOSchema>;

export const TrainingQuizDTOSchema = z.object({
  id: z.string(),
  programId: z.string(),
  workspaceId: z.string(),
  trainingContent: z.string().nullable(),
  questions: z.array(TrainingQuizQuestionDTOSchema),
  passThreshold: z.number(),
  published: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TrainingQuizDTO = z.infer<typeof TrainingQuizDTOSchema>;

export const TrainingQuizAttemptDTOSchema = z.object({
  id: z.string(),
  quizId: z.string(),
  employeeId: z.string(),
  trainingRecordId: z.string(),
  answers: z.array(
    z.object({
      questionIndex: z.number(),
      selectedOption: z.number(),
    })
  ),
  score: z.number(),
  passed: z.boolean(),
  completedAt: z.coerce.date(),
});

export type TrainingQuizAttemptDTO = z.infer<typeof TrainingQuizAttemptDTOSchema>;

// ===== Input DTOs =====

export const GenerateQuizInputDTOSchema = z.object({
  programId: z.string(),
});

export type GenerateQuizInputDTO = z.infer<typeof GenerateQuizInputDTOSchema>;

export const UpdateQuizQuestionsDTOSchema = z.object({
  quizId: z.string(),
  trainingContent: z.string().max(50000).optional(),
  questions: z.array(TrainingQuizQuestionDTOSchema),
  passThreshold: z.number().int().min(1).max(100).optional(),
});

export type UpdateQuizQuestionsDTO = z.infer<typeof UpdateQuizQuestionsDTOSchema>;

export const PublishQuizDTOSchema = z.object({
  quizId: z.string(),
});

export type PublishQuizDTO = z.infer<typeof PublishQuizDTOSchema>;

export const SubmitQuizAttemptInputDTOSchema = z.object({
  quizId: z.string(),
  trainingRecordId: z.string(),
  answers: z.array(
    z.object({
      questionIndex: z.number().int().min(0),
      selectedOption: z.number().int().min(0).max(3),
    })
  ),
});

export type SubmitQuizAttemptInputDTO = z.infer<typeof SubmitQuizAttemptInputDTOSchema>;
